import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';

import { TitleService } from '~/core/services/title/title.service';

@Component({
  selector: 'app-attendee-home',
  templateUrl: './home.component.html',
})
export class AttendeeHomeComponent implements OnInit, OnDestroy {
  private readonly subscriptions = new Subscription();

  constructor(private readonly titleService: TitleService) {}

  public ngOnDestroy(): void {
    this.subscriptions?.unsubscribe();
  }

  public ngOnInit(): void {
    this.titleService.setPageTitle('seo.attendee.home.title');
  }
}
